import { FC } from 'react'
import { cn } from '@bem-react/classname'
import 'swiper/css'
import 'swiper/css/navigation'
import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { Wallet } from '@/core/services/Wallets/WalletInterface'

import './CryptoSlider.scss'
import { trimTrailingZeros } from '@/utils/trimTrailingZeros'

const cnCryptoSlider = cn('Slider')

interface CryptoSliderProps {
  className?: string
  data: Wallet[]
}

export const CryptoSlider: FC<CryptoSliderProps> = ({
  className,
  data,
}: CryptoSliderProps): JSX.Element => {
  return (
    <Swiper
      className={cnCryptoSlider(null, [className])}
      slidesPerView={'auto'}
      modules={[Autoplay]}
      autoplay={{
        pauseOnMouseEnter: true,
        delay: 2500,
      }}
      spaceBetween={36}
    >
      {data.length &&
        data.map((wallet: Wallet, index: number) => (
          <SwiperSlide className={cnCryptoSlider('slide')} key={index}>
            <div className={cnCryptoSlider('left')}>
              <div
                className={cnCryptoSlider(
                  'icon',
                  `icon-${wallet.symbol.toUpperCase()} ${wallet.symbol.toUpperCase()}-color-bg`,
                )}
              ></div>
              <div className={cnCryptoSlider('code')}>
                {wallet.code.toUpperCase()}
              </div>
            </div>
            <div className={cnCryptoSlider('info')}>
              <div className={cnCryptoSlider('small', { up: wallet?.change?.includes('+') || !wallet?.change?.includes('-') })}>
                {wallet?.change?.includes('+') || !wallet?.change?.includes('-') ? (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='6'
                    height='15'
                    viewBox='0 0 6 15'
                    fill='none'
                  >
                    <path
                      d='M0.6 8.7L2.6 6.03333C2.8 5.76667 3.2 5.76667 3.4 6.03333L5.4 8.7C5.64721 9.02962 5.41202 9.5 5 9.5H1C0.587977 9.5 0.352786 9.02962 0.6 8.7Z'
                      fill='#30DAAD'
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='6'
                    height='15'
                    viewBox='0 0 6 15'
                    fill='none'
                  >
                    <g clipPath='url(#clip0_2059_814)'>
                      <path
                        d='M5.4 6.3L3.4 8.96667C3.2 9.23333 2.8 9.23333 2.6 8.96667L0.6 6.3C0.352787 5.97038 0.587978 5.5 1 5.5L5 5.5C5.41202 5.5 5.64721 5.97038 5.4 6.3Z'
                        fill='#FF6A38'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_2059_814'>
                        <rect
                          width='6'
                          height='14'
                          fill='white'
                          transform='translate(0 0.5)'
                        />
                      </clipPath>
                    </defs>
                  </svg>
                )}

                <span>{trimTrailingZeros(wallet.course)}</span>

                {wallet.change && (
                  <>
                    {' · '}
                    <span>{wallet.change}</span>
                  </>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
    </Swiper>
  )
}
